import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { AlarmSettingsModal } from 'components';
import { selectAlarmSettingsView, selectCurrentAlarmSeverityTab, selectIsSubmittingAlertSettings, selectHasDirtyAlarmSettings, selectIsLoadingAlarmSettings } from 'selectors/Settings';
import { AlarmSeverity, AlarmSettingStatus, Device } from 'model';
import { updateNotificationSettingsTab, fetchNotificationSettings, AlarmSettingsPayload, updateNotificationState, saveNotificationSettings } from 'actions';
import { selectHasErrorMessage } from 'selectors';

type SelectedValues = {
  settings: AlarmSettingStatus[];
  currentTab: AlarmSeverity;
  isSubmitting: boolean;
  hasError: boolean;
  hasDirtySettings: boolean,
  isLoading: boolean,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  settings: selectAlarmSettingsView(),
  currentTab: selectCurrentAlarmSeverityTab(),
  isSubmitting: selectIsSubmittingAlertSettings(),
  hasError: selectHasErrorMessage(),
  hasDirtySettings: selectHasDirtyAlarmSettings(),
  isLoading: selectIsLoadingAlarmSettings(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateCurrentTab: (currentTab: AlarmSeverity) => dispatch(updateNotificationSettingsTab(currentTab)),
  fetchNotificationSettings: (userId?: string, device?: Device, locationIds?: string[]) => dispatch(fetchNotificationSettings(userId, device, locationIds)),
  updateNotificationState: (alarmId: number, alarmSettingsPayload: AlarmSettingsPayload) => dispatch(updateNotificationState(alarmId, alarmSettingsPayload)),
  saveNotificationSettings: (userId?: string) => dispatch(saveNotificationSettings(userId)),
});


export default connect(mapStateToProps, mapDispatchToProps)(AlarmSettingsModal);
